import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGetMrTargetData, apiSetMrTarget, apiSetMrTargetStatus } from "services/TargetService";

export const updateMrTargetStatus = createAsyncThunk(
  "target/data/updateMrTargetStatus",
  async (data, {rejectWithValue}) => {
    try {
      const response = await apiSetMrTargetStatus(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getTargetData = createAsyncThunk(
  "target/data/getTargetData",
  async (data, {rejectWithValue}) => {
    try {
      const response = await apiGetMrTargetData(data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveTargetData = createAsyncThunk(
  "target/data/saveTargetData",
  async (data, {rejectWithValue}) => {
    try {
      const response = await apiSetMrTarget(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  mr_id: null,
  target_duration_type: "daily",
  mr_target_status: false,
  product_wise_targets: [],
  call_wise_targets: { productive_call: 0, non_productive_call: 0 },
  loading: false,
};

const dataSlice = createSlice({
  name: "target/data",
  initialState,
  reducers: {
    reset: () => initialState,
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateMrTargetStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMrTargetStatus.fulfilled, (state) => {
        state.loading = false;
        state.mr_target_status = !state.mr_target_status;
      })
      .addCase(getTargetData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTargetData.fulfilled, (state, action) => {
        state.loading = false;
        state.mr_target_status = action.payload.mr_target_status;
        state.product_wise_targets = action.payload.product_wise_targets;
        state.call_wise_targets = action.payload.call_wise_targets;
      })
      .addCase(getTargetData.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveTargetData.fulfilled, (state, action) => {
        state.loading = false;

        const updatedData = action.payload.data ?? [];
        const callTargets = updatedData.filter(item => item.target_type === 'call');
        const productTargets = updatedData.filter(item => item.target_type === 'product');

        const callUpdates = {};
        callTargets.forEach(item => {
          if (item.call_type === 'productive') 
            callUpdates.productive_call = item.target_count;
          else if (item.call_type === 'non_productive') 
            callUpdates.non_productive_call = item.target_count;
        });

        if (Object.keys(callUpdates).length > 0) 
          state.call_wise_targets = { ...state.call_wise_targets, ...callUpdates };

        if (productTargets.length > 0) {
          state.product_wise_targets = state.product_wise_targets.map(product => {
            const updated = productTargets.find(p =>
              p.product_id === product.product_id && p.size_id === product.size_id
            );
            return updated ? { ...product, target_count: updated.target_count } : product;
          });
        }
      })
      .addCase(saveTargetData.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { reset, setLoading } = dataSlice.actions;

export default dataSlice.reducer;